const SearchLoading = () => {
  return <div className="ixi-O-container" />;
};

export default SearchLoading;
